import { HttpClient } from '@angular/common/http';
import { LanguageCode, LocationCode } from '@geneplanet/ngx-utils/src/lib/localization';
import { TranslateLoader } from '@ngx-translate/core';
import { forkJoin, Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export class MultipleFilesHttpTranslationsLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    public resources: { prefix: string; suffix: string }[] = [
      {
        prefix: '/assets/i18n/',
        suffix: '.json',
      },
    ]
  ) {}

  getTranslation(locCode: LocationCode): Observable<any> {
    return forkJoin(
      this.resources.map((config) =>
        this.http
          .get(
            `${config.prefix}${this.getLanguageCodeByLocationCode(locCode)}${
              config.suffix
            }`
          )
          .pipe(catchError(() => of({})))
      )
    ).pipe(
      map((response) =>
        response
          .map((a) => this.parseTranslationsObject(a))
          .reduce((a: any, b: any) => ({
            ...a,
            ...this.parseTranslationsObject(b),
          }))
      )
    );
  }

  private createArrayFromObj(obj: object) {
    const array: any[] = [];
    for (const key of Object.keys(obj)) {
      array.push(obj[key]);
    }
    return array;
  }

  private parseTranslationsObject(input: object) {
    // eslint-disable-next-line no-prototype-builtins
    if (input.hasOwnProperty('0')) {
      const newArray = this.createArrayFromObj(input);
      for (let i = 0; i < newArray.length; i++) {
        if (typeof newArray[i] === 'object') {
          newArray[i] = this.parseTranslationsObject(newArray[i]);
        }
      }
      return newArray;
    } else {
      for (const key of Object.keys(input)) {
        if (typeof input[key] === 'object') {
          input[key] = this.parseTranslationsObject(input[key]);
        }
      }
      return input;
    }
  }

  private getLanguageCodeByLocationCode(locCode: LocationCode): LanguageCode {
    return (
      environment.locations.find((l) => l.code === locCode)?.lang?.code ||
      LanguageCode.EN
    );
  }
}
